import { LtePlusMobiledataTwoTone } from '@mui/icons-material'
import django from '../images/django.png'
import Flask from '../images/Flask.png'
import React_Bootstrap from '../images/React-Bootstrap.png'
import git from '../images/git.png'
import gunicorn from '../images/gunicorn.png'
import nginx from '../images/nginx.png'
import postman from '../images/postman.png'
import tenserflow from '../images/TensorFlow.png'
import keras from '../images/Keras.png'
import AWS from '../images/AWS.png'
import Matplotlib from '../images/Matplotlib.png'
import MySQL from '../images/MySQL.png'
import Numpy from '../images/Numpy.png'
import Pandas from '../images/Pandas.png'
import Ploty from '../images/Ploty.png'
import Scikit_Learn from '../images/Scikit-Learn.png'
import Streamlit from '../images/Streamlit.png'
import PyTorch from '../images/PyTorch.png'
import Jupyter from '../images/Jupyter.png'
import Seaborn from '../images/seaborn.png'
import abharole from '../images/abharole.png'
import hostinger from '../images/hostinger.png'
import bgp from '../images/bgp.jpeg'
import svist from '../images/svist.jpg'
import SVU from '../images/SVU.png'
import pwLogo from '../images/pw_skills.jpg'
import dogVSCat from '../images/ddog-vs-cat-cover-photo.jpeg'
import nltk from '../images/nltk.png'
import campusxLogo from '../images/campusx.jpg'
import CampusXCertificate from '../images/CampusX Certificate.png'
import Realestate from '../images/prediction workflow.png'
import HeroImage from '../images/HeroImage.jpg'
import Ecom from '../images/Ecom.png'
import Movie from '../images/movie.png'
import diploma from '../images/Diploma.jpg'
import githubAction from '../images/GitHub Actions.png'
import github from '../images/github.png'
import cicd from '../images/cicd.png'
import WordPress from '../images/WordPress.png'
import selenium from '../images/Selenium.png'
import soup from '../images/soup.jpg'
import email_project from '../images/email_project.jpeg'
import PyCharm from '../images/PyCharm.png'
import canva from '../images/canva.png'
import tick from '../images/tick.png'
import js from '../images/JavaScript.png'
import candlestick from '../images/candlestick.jpeg'
import gpt from '../images/gpt.jpeg'
import resume from '../images/Dipanjan_Pathak_2025.pdf'
import pwskills from '../images/pwskill_certificate.pdf'
import pwskill from '../images/pwskills_certificate.jpg'
import invisible_man from '../images/invisible_man.jpeg'
import opencv from '../images/OpenCV.png'
import google_logo from '../images/google_logo.png'
import google_cer1 from '../images/Coursera-Google_python_certificate.jpg'
import google_cer2 from '../images/Coursera-Google_python certificate-2.jpg'
import HackerRank_python from '../images/python_HackerRank.jpg'
import HackerRank_logo from '../images/HackerRank_logo.png'
import MedBotImage from '../images/MedBotImage.jpg'
import sql_certificate_HackerRank from '../images/sql_certificate_HackerRank.jpg'
import git_github_certificate from '../images/Git_github_certificate.jpg'
import debugging_certificate from '../images/Troubleshooting_certificate.jpg'
import cloud_certificate from '../images/Configuration&Cloud.jpg'
import Google_IT_Automation_certificate from '../images/Google_IT_Automation_certificate.jpg'
import Automating_Real_World_Tasks_with_Python from '../images/Automating_Real_World_Tasks_with_Python_page.jpg'
import java from "../images/Java.png"
import python from "../images/Python.png"
import HVACImage from "../images/HVACImage.jpg"
import ServerHealthImage from "../images/ServerHealthImage.jpg"
import SAAS from "../images/SAAS.png"



export const Bio = {
  name: "Dipanjan",
  roles: [
    "Data Scientist",
    "Data Analyst",
    "Programmer",
    "MERN Stack Developer",
  ],
  description:
    'Data Scientist and MERN-Stack Developer passionate about transforming data into insights and building scalable AI web applications.',
  github: "https://github.com/dipanjanpathak",
  resume: `${resume}`,
  linkedin: "https://www.linkedin.com/in/dipanjanpathak/",
  insta: "https://www.instagram.com/dipanjan.pathak/",
  facebook: "https://www.facebook.com/dipanjan.pathak.12/",
  leatcode : "https://leetcode.com/u/dipanjanpathak/",
  phone: 'tel:+919064518089'
};

export const skills = [
  {
    title: "Data Science",
    skills: [
          
      // {
      //   name: "JAVA",
      //   image:
      //     `${java}`,
      // },
      {
        name: "Python",
        image:
          `${python}`,
      },
      {
        name: "JavaScript",
        image: js,
      },
      {
        name: "Scikit-Learn",
        image:
          `${Scikit_Learn}`,
      },

      // {
      //   name: "PyTorch",
      //   image:
      //     `${PyTorch}`,
      // },
      {
        name: "TenseFlow",
        image:
          `${tenserflow}`,
      },
      {
        name: "Keras",
        image:
          `${keras}`,
      },
      // {
      //   name: "OpenCV",
      //   image:
      //     `${opencv}`,
      // },

      {
        name: "Numpy",
        image:
          `${Numpy}`,
      },
      {
        name: "Pandas",
        image:
          `${Pandas}`,
      },

      {
        name: "Matplotlib",
        image:
          `${Matplotlib}`,
      },
      {
        name: "Seaborn",
        image:
          `${Seaborn}`,
      },
      {
        name: "Ploty",
        image:
          `${Ploty}`,
      },
      {
        name: "NLTK",
        image:
          `${nltk}`,
      },
      {
        name: "MySQL",
        image:
          MySQL,
      },

      {
        name: "Jupyter",
        image:
          `${Jupyter}`,
      },
      {
        name: "Streamlit",
        image:
          `${Streamlit}`,
      },
    ],
  },
  {
    title: "Skills",
    skills: [
      { name: "EDA", image: tick },
      { name: "Machine Learning", image: tick },
      { name: "Deep Learning", image: tick },
      { name: "Predictive Models", image: tick },
      // { name: "Finance: Option Trading", image: tick },
      { name: "NLP", image: tick },
      { name: "Adaptable and Quick Learner", image: tick },
      // { name: "MLOps", image: tick },
      
      // { name: "Storytelling", image: tick },
      { name: "Problem Solving", image: tick },
      // { name: "Statistics & Data Interpretation", image: tick },
      // { name: "Mathematical Formulations & Modeling", image: tick },
      { name: "MERN Stack", image: tick },
      

    ],
  },


  {
    title: "Tools-Packages & Libraries",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Django",
        image:
          `${django}`,
      },
      {
        name: "Flask",
        image:
          `${Flask}`,
      },
      {
        name: "Redux Toolkit",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },

      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image: js,
      },


      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "React-Bootstrap",
        image:
          `${React_Bootstrap}`,
      },

    ],
  },


  {
    title: "Others",
    skills: [


      {
        name: "Hostinger",
        image:
          `${hostinger}`,
      },
      {
        name: "Postman",
        image:
          `${postman}`,
      },

      {
        name: "Git",
        image:
          `${git}`,
      },
      {
        name: "GitHub",
        image: github,
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },


      // {
      //   name: "Canva",
      //   image:
      //     `${canva}`,
      // },
      {
        name: "WordPress",
        image:
          `${WordPress}`,
      },

      {
        name: "PyCharm",
        image:
          `${PyCharm}`,
      },

    ],
  },

  // {
  //   title: "Others",
  //   skills: [

  //     

  //   ],
  // },
];

export const experiences = [
  {
    id: 0,
    img: `${abharole}`,
    role: "Freelance Website Developer",
    company: "abharole.com",
    date: "Aug 2023 - October 2023",
    desc: "As a freelance web developer, I had the opportunity to design and optimize the website for Abharole, an interior-exterior design firm, using the WordPress platform. I focused on creating a seamless user experience while effectively showcasing their portfolio to highlight their creative capabilities. This project demonstrates my expertise in responsive design and functionality tailored to the needs of the creative sector, ensuring both aesthetics and usability across devices.",
    skills: [
      "Wordpress",
      "Elementor",
      "Woocommerce",
      "Hostinger",
    ],
    // doc: `${abharole}`,
  },


  // {
  //   id: 1,
  //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Rudraksha.jpeg?alt=media&token=8f83f41e-d0a1-486f-9c7f-dd4cd1d09e8d",
  //   role: "Android Developer Intern",
  //   company: "Rudraksha Welffare Foundation",
  //   date: "June 2021 - Oct 2021",
  //   desc: "As an Android Developer Intern at Rudraksha Welfare Foundation from June 2021 to October 2021, I gained valuable hands-on experience in application development. During my tenure, I contributed to the development of the application's back-end cloud functions using Firebase and implemented a front-end with the MVVM structure, which was designed using Figma. I also added a one-to-one video call feature, conceptualized new features, and optimized app performance. This internship helped me enhance my skills in Android development and gave me an opportunity to work in a collaborative team environment.",
  //   skills: [
  //     "Android",
  //     "Java",
  //     "Kotlin",
  //     "XML",
  //     "Node Js",
  //     "Cloud Firestore",
  //     "Firebase",
  //     "Figma",
  //   ],
  //   doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/WhatsApp%20Image%202023-05-05%20at%2012.07.39%20AM.jpeg?alt=media&token=9f0e1648-568b-422d-bd0b-1f125f722245",
  // },
];

export const education = [
  {
    id: 0,
    img: `${bgp}`,
    school: "Baruipur Govt. Polytechnic, South 24 Parganas",
    date: "July 2016 - June 2019",
    grade: "7.72 CGPA",
    desc: "At Baruipur Govt. Polytechnic, I embarked on an enriching journey in Mechanical Engineering, where I achieved a CGPA of 7.72. Throughout my studies, I developed a solid foundation in core mechanical principles and practices. My final year project, which focused on the design and implementation of a back gear cone pulley mechanism, allowed me to apply theoretical knowledge to practical challenges, enhancing my problem-solving and engineering skills. This experience not only deepened my understanding of mechanical systems but also ignited my passion for innovation in the field.",
    degree: "Diploma in Mechanical Engineering (DME)",
    doc: diploma,
  },
  {
    id: 1,
    img: `${svist}`,
    school: "Maulana Abul Kalam Azad University of Technology (MAKAUT), Kolkata ",
    date: "July 2020 - June 2023",
    grade: "8.68 CGPA",
    desc: "At MAKAUT (Maulana Abul Kalam Azad University of Technology), I pursued a Bachelor in Technology (B.Tech) in Mechanical Engineering, graduating with an impressive CGPA of 8.68. My academic journey equipped me with a strong foundation in mechanical principles and applications. For my final year project, I developed a prototype of a hydropower plant, which involved designing and implementing a system for sustainable energy generation. This project deepened my understanding of renewable energy technologies and enhanced my problem-solving skills, reinforcing my commitment to innovative engineering solutions.",
    degree: "B.Tech in Mechanical Engineering",
    // doc: '',
  },
  {
    id: 2,
    img: `${SVU}`,
    school: "Swami Vivekanada University, Kolkata",
    date: "July 2023 - May 2025",
    grade: "--",
    desc: "Currently pursuing MBA in Marketing at Swami Vivekananda University, Kolkata, I am expanding my knowledge and skills in strategic marketing, consumer behavior, and market research. This program allows me to explore innovative marketing strategies and develop a strong business acumen, preparing me for dynamic roles in the marketing landscape. My studies are enhancing my ability to analyze market trends and craft effective marketing campaigns, positioning me for success in the competitive business environment.",
    degree: "MBA in Marketing",
    // doc: '',
  },
];

export const course = [

  {
    id: 0,
    img: `${google_logo}`,
    school: "Google",
    date: "April 2025",
    degree: "Google IT Automation with Python",
    desc: "Successfully completed the 'Google IT Automation with Python' professional certificate offered by Google through Coursera. Gained hands-on experience in Python programming, version control with Git, IT automation, configuration management, cloud infrastructure, and troubleshooting real-world scenarios—preparing for in-demand IT support and automation roles.",
    credential: 'https://www.coursera.org/account/accomplishments/specialization/GFKI0S09LMGE',
    doc: `${Google_IT_Automation_certificate}`
  },

  {
    id: 1,
    img: `${campusxLogo}`,
    school: "CampusX",
    date: "Nov 2022 - August 2024",
  
    desc: `As a participant in the Data Science Mentorship Program (DSMP) at CampusX, I am immersing myself in the intricacies of data science. This program offers in-depth instruction on algorithms, providing a solid foundation in both theoretical concepts and practical applications. I am learning to analyze and interpret complex data sets, employing advanced techniques in data mining, machine learning, statistical analysis and so on. The mentorship aspect of the program enhances my understanding by connecting me with industry professionals, allowing for real-world insights and guidance. Through hands-on projects, I am honing my skills to tackle data-driven challenges effectively, preparing me for a successful career in data science.`,
    credential : "https://learnwith.campusx.in/share-certificate?serialno=CX-DSMP-B1-1302",
    degree: "Data Science Mentorship Program (DSMP)",
    doc: `${CampusXCertificate}`,
  },
  
  {
    id: 2,
    img: `${pwLogo}`,
    school: "Physics Wallah Skills (PW Skills)",
    date: "December 2023 - January 2025",
    degree: "Full Stack Data Science Pro (FSDS)",

    desc: "As a student in the Full Stack Data Science Pro course at Physics Wallah Skills, I am gaining a comprehensive understanding of data science concepts. This program focuses on key areas such as data analysis, machine learning, deep learning, data visualization and so on, utilizing essential programming languages like Python and SQL. Through hands-on projects, I am developing practical skills that prepare me for a successful career in the dynamic field of data science.",
    credential : 'https://pwskills.com/learn/certificate/21b6230e-0d99-4511-9a9b-33826a84708b/',
     doc: `${pwskill}`,
  },
    
  {
    id: 3,
    img: `${google_logo}`,
    school: "Google",
    date: "March 2025 - April 2025",
    degree: "Crash Course on Python",

    desc: "Successfully completed the Crash Course on Python, an online program by Google on Coursera. This course covered the fundamentals of Python programming, including variables, loops, functions, and data structures. It also introduced automation concepts and problem-solving techniques, laying a strong foundation for real-world applications in IT and data science.",
    credential : 'https://www.coursera.org/account/accomplishments/records/4SK6E8K7HOH8',
     doc: `${google_cer1}`,
  },
  {
    id: 4,
    img: `${google_logo}`,
    school: "Google",
    date: "March 2025 - April 2025",
    degree: "Python to Interact with the Operating System",

    desc: "Successfully completed 'Python to Interact with the Operating System,' an online course by Google on Coursera. This course covered essential concepts of using Python for system automation, file handling, regular expressions, and process management. It also introduced interacting with the command line, manipulating files and directories, and automating repetitive system tasks, providing practical skills for IT automation and scripting.",
    
    credential: "https://www.coursera.org/account/accomplishments/records/15ON4EM4LWPI",
    doc: `${google_cer2}`,
},
  {
    id: 5,
    img: `${HackerRank_logo}`,
    school: "HackerRank",
    date: "March 2025",
    degree: "Python Certification",
    desc: "Successfully completed the Python Certification on HackerRank, which included the fundamentals of Python programming, such as variables, loops, functions, and data structures. This certification demonstrates proficiency in Python and covers core concepts necessary for building real-world applications in IT and data science.",
    credential: 'https://www.hackerrank.com/certificates/iframe/9cbc3aad35b1',
    doc: `${HackerRank_python}`
  },
  
  {
    id: 6,
    img: `${HackerRank_logo}`,
    school: "HackerRank",
    date: "March 2025",
    degree: "SQL Advanced Certification",
    desc: "Successfully completed the SQL Advanced Certification on HackerRank, which included advanced SQL concepts such as complex queries, subqueries, joins, window functions, and database optimization. This certification demonstrates expertise in SQL and the ability to manage and manipulate large datasets, along with proficiency in writing efficient SQL queries for real-world applications.",
    credential: 'https://www.hackerrank.com/certificates/iframe/2ab7fee2e7e3',
    doc: `${sql_certificate_HackerRank}`
  },
  {
    id: 7,
    img: `${google_logo}`,
    school: "Google",
    date: "April 2025",
    degree: "Introduction to Git and GitHub",
    desc: "Completed the 'Introduction to Git and GitHub' course offered by Google through Coursera. Developed a solid foundation in version control, including branching, merging, resolving conflicts, and collaborating on GitHub. Gained practical experience with workflows used in professional software development and open-source contribution environments.",
    credential: 'https://www.coursera.org/account/accomplishments/records/ZY68BF547SYK',
    doc: `${git_github_certificate}`
  },
  {
    id: 8,
    img: `${google_logo}`,
    school: "Google",
    date: "April 2025",
    degree: "Troubleshooting and Debugging Techniques",
    desc: "Completed the 'Troubleshooting and Debugging Techniques' course offered by Google through Coursera. Gained hands-on experience in diagnosing and resolving technical issues, utilizing debugging tools, and applying best practices for troubleshooting in real-world IT and software environments. Enhanced problem-solving skills for efficient issue resolution in various projects.",
    credential: 'https://www.coursera.org/account/accomplishments/records/95W0SBELZCG8',
    doc: `${debugging_certificate}`
  },
  {
    id: 9,
    img: `${google_logo}`,
    school: "Google",
    date: "April 2025",
    degree: "Configuration Management and the Cloud",
    desc: "Successfully completed the 'Configuration Management and the Cloud' course offered by Google through Coursera. Acquired practical knowledge in managing systems at scale using configuration management tools like Puppet and Chef. Gained insights into cloud infrastructure, automation, and orchestration, enabling efficient deployment, monitoring, and maintenance of cloud-based environments.",
    credential: 'https://www.coursera.org/account/accomplishments/records/4QV3NYTR9YXV',
    doc: `${cloud_certificate}`
  },
  {
    id: 10,
    img: `${google_logo}`,
    school: "Google",
    date: "April 2025",
    degree: "Automating Real-World Tasks with Python",
    desc: "Completed the 'Automating Real-World Tasks with Python' course as part of the Google IT Automation with Python Professional Certificate on Coursera. Developed practical skills in using Python to automate common system administration tasks such as batch processing, working with files, data serialization, regular expressions, and web services. Created scripts to streamline and scale real-world IT workflows.",
    credential: 'https://www.coursera.org/account/accomplishments/verify/XYURZUKWF6XN',
    doc: `${Automating_Real_World_Tasks_with_Python}`
  },
{
  "id": 10,
  img: `${google_logo}`,
  school: "YouTube",
  date: "April 2024",
  degree: "Machine Learning Specialization by Andrew Ng",
  // credential: "https://www.coursera.org/account/accomplishments/verify/XYURZUKWF6XN",
  desc: "Completed the Machine Learning Specialization by Andrew Ng, gaining a strong foundation in core machine learning concepts and practical applications. Learned supervised and unsupervised learning techniques, including linear and logistic regression, decision trees, neural networks, and clustering. Developed skills in model training, evaluation, and optimization using gradient descent, regularization, and bias-variance analysis. Applied machine learning algorithms using Python and libraries such as NumPy and scikit-learn to solve real-world problems.",
  // doc: "${Automating_Real_World_Tasks_with_Python}"
  },
{
  "id": 11,
  img: `${google_logo}`,
  school: "YouTube",
  date: "july 2024",
  degree: "Deep Learning Specialization by Andrew Ng",
  // credential: "https://www.coursera.org/account/accomplishments/verify/XXXXXXX",
  desc: "Completed the Deep Learning Specialization by Andrew Ng, gaining in-depth knowledge of neural networks and modern deep learning techniques. Learned to build and train deep neural networks using forward and backpropagation, optimization algorithms, and regularization methods. Studied convolutional neural networks (CNNs) for image recognition, recurrent neural networks (RNNs) and LSTMs for sequence modeling, and techniques such as dropout, batch normalization, and hyperparameter tuning. Applied deep learning models using Python and frameworks like TensorFlow and Keras to solve real-world problems.",
  // doc: "${Deep_Learning_Specialization}"
}



  
  
  
  
  

];

export const projects = [
  {
  id: 0,
  title: "AI Media Generation (Multi-Tenant SaaS Project)",
  date: "February 2025 - July 2025",
  description:
    `⚠️ Source code is not publicly available. If you are interested in reviewing the project, please contact me to view a live demonstration running on my localhost.\n\nDeveloped a multi-tenant AI SaaS platform for image and video generation using Runway ML APIs. Integrated OpenAI API to intelligently enhance and optimize user prompts for improved media generation quality. Implemented secure, tenant-specific API key management using HashiCorp Vault to ensure data isolation and security.\n\nBuilt dedicated admin and tenant dashboards with Razorpay payment integration, including a split-payment system where user payments are routed to tenant accounts while platform service fees are credited to the main project account. Designed the system to support scalability, secure authentication, and seamless multi-tenant operations, combining modern AI capabilities with a robust SaaS architecture.`,
  image: `${SAAS}`,
  tags: [
    "Flask",
    "React Js",
    "JavaScript",
    "Python",
    "MongoDB",
    "Razorpay",
    "Runway ML API",
    "OpenAI API",
    "HashiCorp Vault",
    "Multi-Tenant SaaS"
  ],
  category: "machine learning",
  // github: "Private Repository",
  // webapp: "Live demo available on request",
  member: [
    {
      name: Bio.name,
      img: `${HeroImage}`,
      linkedin: Bio.linkedin,
      github: Bio.github
    }
  ]
},

  {
    id: 1,
    title: "MERN Stack Realestate Machine Learing app",
    date: "August 2024 - October 2024",
    description:
      "I developed a full-featured real estate web application using the MERN stack, incorporating a machine learning price prediction model. The platform allows users to input property details and receive accurate price predictions, along with a curated list of the top 10 related properties based on their search. Each property page also includes suggestions for additional relevant listings. Additionally, the application offers a statistical visualization feature, enabling users to explore various parameters and gain insights into different locations.This project combines advanced machine learning techniques with a user- friendly interface to enhance the real estate browsing experience.",
    image:
      `${Realestate}`,
    tags: [
      "Scikit-Learn",
      "Numpy",
      "Pandas",
      "React Js",
      "React-Bootstrap",
      "JavaScript",
      "Node Js",
      "Express Js",
      "Python",
      "Django",
      "MongoDb",
      "NGINX",
      "Gunicorn",
      "Hostinger",
    ],
    category: "machine learning",
    github: "https://github.com/dipanjanpathak/Master_ML-MERN-Realestate",
    webapp: "https://property.dipanjan.tech",
    member: [
      {
        name: Bio.name,
        img: `${HeroImage}`,
        linkedin: Bio.linkedin,
        github: Bio.github,
      }
    ],
  },
  

  {
    id: 1,
    title: "Mini GPT model",
    date: "January 2025",
    description:
      "This project is a minimal GPT implementation focused on a question-answering system. The model was trained from scratch on the WikiText-2 dataset without leveraging transfer learning or pretrained models, resulting in limited performance. It serves as an educational experiment to explore the fundamentals of training language models from scratch.",
    image:
      `${gpt}`,
    tags: [
      'PyTorch',
      'python',
      'Jupyter'
      
    ],
    category: "machine learning",
    github: "https://github.com/dipanjanpathak/mini-gpt-model",
    // webapp: "https://property.dipanjan.tech",
    member: [
      {
        name: "Dipanjan Pathak",
        img: `${HeroImage}`,
        linkedin: Bio.linkedin,
        github: Bio.github,
      }
    ],
  },
  {
    id: 1,
    title: "Text generation model",
    date: "March 2025",
    description:
      "This project is a minimal text generation implementation focused on a question-answering system. The model was trained from scratch on the custom dataset without leveraging transfer learning or pretrained models, resulting in limited performance. It serves as an educational experiment to explore the fundamentals of training language models from scratch.",
    image:
      `${gpt}`,
    tags: [
      'Tenserflow',
      'python',
      'Jupyter'
      
    ],
    category: "machine learning",
    github: "https://github.com/dipanjanpathak/lstm-next-word-prediction",
    // webapp: "https://property.dipanjan.tech",
    member: [
      {
        name: "Dipanjan Pathak",
        img: `${HeroImage}`,
        linkedin: Bio.linkedin,
        github: Bio.github,
      }
    ],
  },


  {
    id: 2,
    title: "Cold Email Generator",
    date: "December 2024",
    description:
      "This project is an AI-powered cold email generator designed to craft personalized and professional email templates for outreach. Built with advanced natural language processing (NLP) models, it enables users to input key details and generate tailored emails for various use cases, such as sales, networking, or recruitment.",
    image:
      `${email_project}`,
    tags: [
      'langchain',
      'langchain-community',
      'langchain-groq',
      'selenium',
      'chromadb',
      'streamlit',
      'pandas'
    ],
    category: "machine learning",
    github: "https://github.com/dipanjanpathak/cold_E-Mail_generator",
    // webapp: "https://property.dipanjan.tech",
    member: [
      {
        name: "Dipanjan Pathak",
        img: `${HeroImage}`,
        linkedin: Bio.linkedin,
        github: Bio.github,
      }
    ],
  },


  {
    id: 3,
    title: "Stock Price Prediction",
    date: "November 2024",
    description:
      "This project focuses on predicting stock prices using day-wise historical data (2000–2024) obtained from Yahoo Finance. It employs data preprocessing and machine learning techniques to analyze trends and forecast future stock prices, providing insights for financial analysis and decision-making.",
    image:
      `${candlestick}`,
    tags: ["TensorFlow",
      'Keras',
      'LSTM',
      'Jupyter',
      "Numpy",
      "Pandas",
      'Matplotlib',
      "Python",
      "Django",
     
    ],
    category: "machine learning",
    github: "https://github.com/dipanjanpathak/Stock-Price-Prediction",
    // webapp: "https://property.dipanjan.tech",
    member: [
      {
        name: "Dipanjan Pathak",
        img: `${HeroImage}`,
        linkedin: Bio.linkedin,
        github: Bio.github,
      }
    ],
  },


  {
    id: 4,
    title: "MERN Stack Movie Recommendation app",
    date: "July 2024 - August 2024",
    description:
      "I developed this movie recommendation system using the MERN stack and Python-based machine learning libraries. Users can search for a movie title and receive a curated list of the top 10 related movie recommendations. The project utilizes Django to serve the machine learning API, while Node.js and Express manage data retrieval from the MongoDB database. Front-end interactions are handled by React, creating a seamless and user-friendly experience. This application effectively combines machine learning with a robust web architecture to enhance movie discovery.",
    image:
      `${Movie}`,
    tags: ["Scikit-Learn",
      "Numpy",
      "Pandas",
      "React Js",
      "React-Bootstrap",
      "JavaScript",
      "Node Js",
      "Express Js",
      "Python",
      "Django",
      "MongoDb",
    ],
    category: "machine learning",
    github: "https://github.com/dipanjanpathak/MERN_Movie_Recomendation",
    // webapp: "https://property.dipanjan.tech",
    member: [
      {
        name: "Dipanjan Pathak",
        img: `${HeroImage}`,
        linkedin: Bio.linkedin,
        github: Bio.github,
      }
    ],
  },
 
  
  {
    id: 5,
    title: "Fine Tune Dog vs Cat Classifier",
    date: "November 2024",
    description:
      "In this project, I fine-tuned a Dog vs Cat classifier, improving its accuracy from 95% to 98%. The model is developed using TensorFlow and Keras with a Convolutional Neural Network (CNN) architecture that includes layers like Conv2D, MaxPooling2D, and Dropout to enhance performance. Leveraging the VGG16 pre-trained model for feature extraction, I fine-tuned it for the specific classification task. Image data is processed using ImageDataGenerator for real-time augmentation. The model is trained and optimized using the Adam optimizer, achieving high precision and robustness in predictions.",
    image:
      `${dogVSCat}`,
    tags: [
      "TensorFlow",
      "Keras",
      "VGG16",
      "ImageDataGenerator",
      "Conv2D",
      "MaxPooling2D",
      "Dropout",
      "Adam",
      "OpenCV",
      "Matplotlib",
    ],
    category: "machine learning",
    github: "https://github.com/dipanjanpathak/Dog-vs-Cat-Classifier",
    // webapp: "https://property.dipanjan.tech",
    member: [
      {
        name: "Dipanjan Pathak",
        img: `${HeroImage}`,
        linkedin: Bio.linkedin,
        github: Bio.github,
      }
    ],
  },


  {
    id: 6,
    title: "Invisibility Cloak OpenCV",
    date: "January 2025",
    description:
      'This project demonstrates an invisibility cloak effect using OpenCV in Python. It leverages HSV color space masking, trackbars for dynamic range adjustment, and real-time video processing to replace specific color ranges with a background frame, creating a magical invisibility effect.',
    image:
      `${invisible_man}`,
    tags: [
      'python' ,'opencv', 'computer-vision', 'hsv-color-detection',
    ],
    category: "machine learning",
    github: "https://github.com/dipanjanpathak/Invisibility-Cloak-OpenCV",
    // webapp: "https://property.dipanjan.tech",
    member: [
      {
        name: "Dipanjan Pathak",
        img: `${HeroImage}`,
        linkedin: Bio.linkedin,
        github: Bio.github,
      }
    ],
  },

  
  {
    id: 7,
    title: "MERN Stack E-Commerce app",
    date: "March 2024 - June 2024",
    description:
      "I developed this fully functional e-commerce website using the MERN stack, featuring user authentication and validation for a secure shopping experience. The platform includes a seamless payment processing system, allowing users to browse products, add them to their cart, and complete transactions with ease. The application emphasizes a user-friendly interface and robust backend functionality, showcasing my ability to create scalable web applications that meet modern e-commerce needs.",
    image:
      `${Ecom}`,
    tags: [
      "React Js",
      "Redux Toolkit",
      "JavaScript",
      "Node Js",
      "Express Js",
      "MongoDb",
      "React-Bootstrap",
      "React-Redux",
      "Razorpay",
    ],
    category: "web app",
    github: "https://github.com/dipanjanpathak/ML_Project-MERN_Ecom",
    // webapp: "https://property.dipanjan.tech",
    member: [
      {
        name: "Dipanjan Pathak",
        img: `${HeroImage}`,
        linkedin: Bio.linkedin,
        github: Bio.github,
      }
    ],
  },
  {
    id: 8,
    title: "Medical Chatbot with Document Retrieval",
    date: "March 2025",
    description:
      "Developed an AI-powered medical Q&A system using LangChain and HuggingFace models, with FAISS vector search for efficient document retrieval from the GALE Encyclopedia of Medicine. Implemented Streamlit for the frontend interface and optimized document chunking strategies to improve response accuracy while reducing LLM hallucinations. The system demonstrates advanced NLP techniques for healthcare information retrieval.",
    image: `${MedBotImage}`,
    tags: [
      "LangChain",
      "HuggingFace",
      "FAISS",
      "Python",
      "Streamlit",
      "NLP",
      "Vector Databases",
      "LLMs",
      "PyPDF"
    ],
    category: "AI/ML",
    github: "https://github.com/dipanjanpathak/medical-chatbot",
    // webapp: "https://medical-chatbot.dipanjan.tech",
    member: [
      {
        name: "Dipanjan Pathak",
        img: `${HeroImage}`,
        linkedin: Bio.linkedin,
        github: Bio.github,
      }
    ],
  },
  {
  id: 9,
  title: "HVAC Systems Health Analysis",
  date: "July 2025",
  description:
    "Developed a machine learning-based system to predict overheating and ensure early fault detection in HVAC systems using real-time sensor data. Employed XGBoost for classification, MinMaxScaler for feature normalization, and handled class imbalance with SMOTE. Engineered features such as T_Supply, T_Return, RH_Outdoor, and Energy to accurately identify health status. The model achieved high precision and recall, with future alert capabilities built in for predictive maintenance.",
  image: `${HVACImage}`,
  tags: [
    "XGBoost",
    "SMOTE",
    "MinMaxScaler",
    "Scikit-Learn",
    "Python",
    "Data Preprocessing",
    "Predictive Maintenance",
    "HVAC Systems",
    "Machine Learning"
  ],
  category: "AI/ML",
  github: "https://github.com/dipanjanpathak/HVAC-Systems-Anomaly-Detection/tree/master",
  // webapp: "https://hvac-monitor.dipanjan.tech",
  member: [
    {
      name: "Dipanjan Pathak",
      img: `${HeroImage}`,
      linkedin: Bio.linkedin,
      github: Bio.github,
    }
  ]
  },
  
  {
  id: 10,
  title: "Server Health Analysis Prediction Model",
  date: "July 2025",
  description:
    "Built a machine learning pipeline to predict server health based on real-time system metrics such as CPU usage, memory, and temperature. Leveraged data preprocessing, feature engineering, and model evaluation to optimize accuracy. Integrated with a monitoring dashboard using Streamlit for real-time visualization. The model helps anticipate potential failures and ensures proactive server maintenance.",
  image: `${ServerHealthImage}`,  
  tags: [
    "Machine Learning",
    "Python",
    "Scikit-Learn",
    "Pandas",
   "Matplotlib",
   "Seaborn",
   "Plotly",
    "Data Visualization",
    "System Monitoring",
    "Predictive Analytics"
  ],
  category: "AI/ML",
  github: "https://github.com/dipanjanpathak/Sever-Health-Checkup-Model",  
  // webapp: "https://server-health.dipanjan.tech", 
  member: [
    {
      name: "Dipanjan Pathak",
      img: `${HeroImage}`,
      linkedin: Bio.linkedin,
      github: Bio.github,
    }
  ]
}



];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
